import { Box, Button, Flex, Text } from '@chakra-ui/react';

import SpannedText from '@pages/UploadMappingV2/components/ui/spannedText';
import { DownloadIcon } from '@assets/icons';
import { useFileUploadPopUp } from '@store/useFileUploadPopUp';
import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import FileUploadField from '../../../components/ui/FileUploadField';
import useMutateUploadMapping from '@pages/UploadMappingV2/hooks/mutate/useMutateUploadMapping';
import { fileDownloader } from '@helpers/utils';
import getUploadTutorial from '@hooks/tutorial/upload/getUpload';

export default function UploadMassal() {
    const { set, files } = useFileUploadPopUp();
    const { uploadProdukMassal } = useMutateUploadMapping();
    const { data: uploadTutorial } = getUploadTutorial();

    const handleDonwnloadTemplate = () => {
        fileDownloader({
            url: '/api/v2/sellout/product-mapping/download-template-massal',
            fileName: 'Template Upload Massal.xlsx',
        });
    };

    useEffect(() => {
        if (!isEmpty(files)) {
            set({
                isOpen: true,
                title: 'Upload Produk',
                uploadProgressMessage: 'Sedang memeriksa data produk master ...',
                isCanCancelUpload: true,
                uploadButtonText: 'Cek & Upload',
                isShowDownloadTemplate: false,
                helperText: {
                    isShow: true,
                    text: 'Temukan Panduan Mapping Disini!',
                    isLink: true,
                    url: uploadTutorial,
                },

                onUploadFile: () => {
                    set({
                        isUploading: true,
                    });
                    uploadProdukMassal.mutate({ files: files });
                },
                onCancelUpload: () => {
                    set({
                        isUploading: false,
                    });
                },
            });
        }
    }, [files]);

    return (
        <Box>
            <Flex justifyContent={'space-between'} alignItems={'center'} mb={'24px'}>
                <Box>
                    <Text fontWeight={'600'} fontSize={'20px'} mb={'8px'}>
                        Upload Massal
                    </Text>

                    <Text fontSize={'14px'}>
                        Pelajari cara upload data mapping dengan melihat{' '}
                        <SpannedText isUrl url={uploadTutorial}>
                            panduan upload
                        </SpannedText>
                        .
                    </Text>
                </Box>
                <Button variant={'outline'} onClick={handleDonwnloadTemplate}>
                    <DownloadIcon strokeWidth={1.8} size={20} />
                    Download Template
                </Button>
            </Flex>

            <FileUploadField />
        </Box>
    );
}
